import React, { useState } from "react";
import "./Inner.css";
import "./Contact.css";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [status, setStatus] = useState({ state: "idle", text: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", text: "" });
    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Something went wrong.");
      setStatus({ state: "success", text: "Thank you — we've received your message and will be in touch soon." });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      setStatus({ state: "error", text: err.message || "Unable to send your message right now." });
    }
  };

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: "#F2FAFA" }}>Contact</span>
          <h1>Let's Help You Hear Better</h1>
        </div>
      </section>

      <section>
        <div className="container contact-grid">
          <div>
            <p>
              Whether you're looking for a hearing assessment, hearing aid, flexible payment
              options or simply have questions, we'd love to hear from you.
            </p>

            <div className="contact-details">
              <div className="contact-detail">
                <span className="eyebrow">Phone</span>
                <p>+234 000 000 0000</p>
              </div>
              <div className="contact-detail">
                <span className="eyebrow">Email</span>
                <p>hello@hearmenders.com</p>
              </div>
              <div className="contact-detail">
                <span className="eyebrow">Address</span>
                <p>Ibadan, Nigeria</p>
              </div>
              <div className="contact-detail">
                <span className="eyebrow">WhatsApp</span>
                <p>+234 000 000 0000</p>
              </div>
            </div>
            
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label>
              Full name
              <input type="text" name="name" required value={form.name} onChange={handleChange} />
            </label>
            <label>
              Email address
              <input type="email" name="email" required value={form.email} onChange={handleChange} />
            </label>
            <label>
              Phone number
              <input type="tel" name="phone" value={form.phone} onChange={handleChange} />
            </label>
            <label>
              How can we help?
              <textarea name="message" rows="5" required value={form.message} onChange={handleChange} />
            </label>
            <button type="submit" className="btn btn-primary" disabled={status.state === "loading"}>
              {status.state === "loading" ? "Sending…" : "Send Message"}
            </button>
            {status.text && (
              <p className={status.state === "error" ? "form-error" : "form-success"}>{status.text}</p>
            )}
          </form>
        </div>
      </section>
    </>
  );
}
